import React from 'react';
import { Card, Typography, Switch, Select, Form, Button, Divider, Space, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { useAppStore } from '../../store/appStore';

const { Title, Text } = Typography;

const Settings: React.FC = () => {
  const [form] = Form.useForm();
  const themeMode = useAppStore((state) => state.themeMode);
  const setThemeMode = useAppStore((state) => state.setThemeMode);

  const onFinish = (values: any) => {
    setThemeMode(values.theme);
    message.success('Configurações salvas!');
  };

  return (
    <div>
      <Title level={4}>Configurações</Title>

      <Card title="Preferências Gerais">
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{
            language: 'pt-BR',
            theme: themeMode,
            notifications: true,
            email_notifications: true,
            session_timeout: 30,
            default_view: 'dashboard',
          }}
        >
          <Form.Item name="language" label="Idioma">
            <Select>
              <Select.Option value="pt-BR">Português (Brasil)</Select.Option>
              <Select.Option value="en-US">English (US)</Select.Option>
              <Select.Option value="es">Español</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item name="theme" label="Tema">
            <Select>
              <Select.Option value="light">Claro</Select.Option>
              <Select.Option value="dark">Escuro</Select.Option>
              <Select.Option value="auto">Automático</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item name="default_view" label="Página Inicial">
            <Select>
              <Select.Option value="dashboard">Dashboard</Select.Option>
              <Select.Option value="devices">Dispositivos</Select.Option>
              <Select.Option value="sessions">Sessões</Select.Option>
            </Select>
          </Form.Item>

          <Form.Item name="session_timeout" label="Timeout de Sessão (minutos)">
            <Select>
              <Select.Option value={15}>15 minutos</Select.Option>
              <Select.Option value={30}>30 minutos</Select.Option>
              <Select.Option value={60}>1 hora</Select.Option>
              <Select.Option value={120}>2 horas</Select.Option>
            </Select>
          </Form.Item>

          <Divider />

          <Title level={5}>Notificações</Title>

          <Form.Item name="notifications" label="Notificações no Sistema" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Form.Item name="email_notifications" label="Notificações por E-mail" valuePropName="checked">
            <Switch />
          </Form.Item>

          <Divider />

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
              Salvar Configurações
            </Button>
          </Form.Item>
        </Form>
      </Card>

      <Card title="Sobre" style={{ marginTop: 16 }}>
        <Space direction="vertical">
          <Text><strong>Layout Remote</strong> - v1.0.0</Text>
          <Text type="secondary">Solução de acesso remoto corporativo baseada no RustDesk</Text>
          <Text type="secondary">&copy; 2024 Layout Sistemas. Todos os direitos reservados.</Text>
        </Space>
      </Card>
    </div>
  );
};

export default Settings;
